import type { Theme } from '../../core/theme';
import { xAxisThemeParse } from './component/xAxis';
import { tooltipThemeParse } from '../ainvest/component/tooltip';
import { axisPointerThemeParse } from '../ainvest/component/axisPointer';
import { dataZoomThemeParse } from './component/datazoom';
import { colorThemeParse } from '../ainvest/component/color';
import { yAxisThemeParse } from './component/yAxis';
import { gridThemeParse } from './component/grid';
import { barThemeParse } from '../ainvest/series/bar';
import { progressBarThemeParse } from '../ainvest/series/progress';
import { lineThemeParse } from './series/line';
import { pieThemeParse } from './series/pie';
import { graphicParse } from './component/graphic';

export const ainvestPcLight = {
  name: 'ainvest-pc-light' as const,
  parsers: [
    // component -------------------------------------------------------
    xAxisThemeParse,
    tooltipThemeParse,
    axisPointerThemeParse,
    dataZoomThemeParse,
    yAxisThemeParse,
    gridThemeParse,
    colorThemeParse,
    graphicParse,

    // series -------------------------------------------------------
    barThemeParse,
    progressBarThemeParse,
    lineThemeParse,
    pieThemeParse
  ]
} as Theme;

export const ainvestPcDark = {
  name: 'ainvest-pc-dark' as const,
  parsers: [
    // component -------------------------------------------------------
    xAxisThemeParse,
    tooltipThemeParse,
    axisPointerThemeParse,
    dataZoomThemeParse,
    yAxisThemeParse,
    gridThemeParse,
    colorThemeParse,
    graphicParse,

    // series -------------------------------------------------------
    barThemeParse,
    progressBarThemeParse,
    lineThemeParse,
    pieThemeParse
  ]
} as Theme;
